import { Link } from "react-router-dom";
import { ArrowRight } from "@/components/Icon";
import { Button } from "@/components/ui/button";

interface LandingCTAProps {
  title: string;
  description: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel: string;
  secondaryTo: string;
}

const LandingCTA = ({
  title,
  description,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
}: LandingCTAProps) => (
  <div className="rounded-2xl border border-border bg-card p-6 text-center sm:p-8">
    <h2 className="text-2xl font-bold text-foreground">{title}</h2>
    <p className="mx-auto mt-3 max-w-2xl leading-relaxed text-muted-foreground">{description}</p>
    <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
      <Button size="lg" asChild>
        <Link to={primaryTo}>{primaryLabel} <ArrowRight className="ml-2 h-4 w-4" /></Link>
      </Button>
      <Button size="lg" variant="outline" asChild>
        <Link to={secondaryTo}>{secondaryLabel}</Link>
      </Button>
    </div>
  </div>
);

export default LandingCTA;